import React from 'react';
import { Box, CardContent, CardHeader, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import dayjs from 'dayjs';
import { MessageCard } from '@components/feed/Feed/components/MessageCard';
import { useRelativeTime } from '@context/TimeContext';
import { formatRelativeTime } from '@helpers/formatRelativeTimeHelper';
import { NotificationAvatar } from '@notifications/components/NotificationAvatar';
import { NotificationMessage } from '@notifications/components/NotificationMessage';
import { getNotificationBody } from '@notifications/registry';
import { INotificationCard } from './interfaces';

export const NotificationCard: React.FC<INotificationCard> = ({
  notification,
  onClick,
}): JSX.Element => {
  const now = useRelativeTime();
  const theme = useTheme();
  const unread = notification.readAt === null;
  const body = getNotificationBody(notification);
  const unreadBackground = alpha(theme.palette.primary.main, 0.1);

  return (
    <Box onClick={() => onClick(notification)}>
      <MessageCard
        sx={{
          pb: body ? undefined : '16px',
          backgroundColor: unread ? unreadBackground : undefined,
          '@media (hover: hover) and (pointer: fine)': {
            '&:hover': {
              backgroundColor: unread
                ? alpha(theme.palette.primary.main, 0.16)
                : theme.palette.grey[100],
              cursor: 'pointer',
            },
          },
        }}
      >
        <CardHeader
          avatar={<NotificationAvatar notification={notification} />}
          title={<NotificationMessage notification={notification} />}
          subheader={formatRelativeTime(now, dayjs(notification.createdAt))}
          sx={{
            pb: 0,
          }}
        />
        {body && <CardContent>{body}</CardContent>}
      </MessageCard>
    </Box>
  );
};
